export default {_name:'grid.form.section.button',module:'Card/Form',view:'Element/Section/AsButton',options:{component:'section',xs:4,ms:4,block:{xs:4,ms:4}}}